import { DateTime } from 'luxon';
import { DateTimeString } from '@deltasierra/dates';

type UserBrowsingInfoForAssetReporting = {
    browser: string;
    timestamp: DateTimeString;
    timezone: string;
};

export function getUserBrowsingInfoForAssetReporting(): UserBrowsingInfoForAssetReporting {
    return {
        browser: window.navigator.userAgent,
        timestamp: DateTimeString.from(DateTime.utc().toISO() ?? new Date(Date.now()).toISOString()),
        timezone: DateTime.now().zoneName ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
}
